// project imports
import config from 'config';
import { DEFAULT_THEME } from 'constants/settings';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    isOpen: [], // for active default menu
    pageTitle: [], // for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true,
    presetColor: DEFAULT_THEME,
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action: any) => {
    let id;
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id],
            };
        case actionTypes.SET_PAGE_TITLE:
            return {
                ...state,
                pageTitle: action.title,
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened,
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily,
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius,
            };
        case actionTypes.SET_THEME:
            return {
                ...state,
                presetColor: action.presetColor,
            };
        default:
            return state;
    }
};

export default customizationReducer;
